<div class=" p_re padding">
    <div>
        <div class="left-align ">
            <p class="filter-action">
                <img class="icon-edit cursor-pointer flex-item" src="assets/images/ihs/filter.png" alt="filter" />
                Filters
            </p>
        </div>
        <div class="right-align">
            <button type="button" name="createUser" class="close-action" (click)="closeDialog()">
                Close
            </button>
        </div>
    </div>
    <div class="clear-filter cursor-pointer" (click)="clearFilters()">
        <p [hidden]="!isSubmitted">Clear Filters</p>
    </div>
    <div class="pull-down padding">
        <form [formGroup]='filterLeadForm'>
            <div class="row m_bt_20 dt-pic mr-20">
                <label class="fn_h"> Date Range</label>
                <div class="daterange-picker">
                    <!-- <input type="text" name="daterangeInput" [max]="maxDate" daterangepicker
                        (applyDaterangepicker)="applyDatePickerFilteredLeads($event)" /> -->
                    <div class="svg_dt">
                        <span class="mat-button-wrapper"><svg viewBox="0 0 24 24" width="24px" height="24px"
                                fill="currentColor" focusable="false"
                                class="mat-datepicker-toggle-default-icon ng-star-inserted">
                                <path
                                    d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z">
                                </path>
                            </svg>
                            <!--bindings={
									"ng-reflect-ng-if": "true"
								  }--></span>
                    </div>
                </div>

            </div>

            <div class="row m_bt_20 mr-20">
                <div class="col-md-4" *ngFor="let tool of tools">
                    <button rm [class]="tool.class" (click)="handleClick(tool)">
                        <span> {{tool.click}}</span>
                    </button>
                </div>

            </div>
            <div class='contentWidth'>
                <label class="fn_h">
                    Lead Age
                </label>
                <div class="col-sm-12  m_bt_20 row mr-20">
                    <div class="col-sm-4 p-0" *ngFor="let item of leadAge">
                        <mat-checkbox [checked]="item.checked" (change)="showOptions($event,item)" [value]="item.id">
                            <span class='mat-checkbox-label'> {{item.days}}
                            </span></mat-checkbox>
                        <br />
                    </div>
                </div>
            </div>
            <div>
                <label class="fn_h">User</label>
                <ng-select class="m_bt_20" [items]="users" bindLabel="userid" bindValue="userid"
                    dropdownPosition="bottom" formControlName='user' (change)="userSelection($event)" [multiple]="true"
                    [searchable]="true" (clear)="clearUser()" (remove)="removeUser($event)" #selectUser>
                    <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.userid}}">{{item.userid}}</div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="m_bt_20">
                <label class="fn_h">Pincode</label>
                <ng-select [items]="options" (change)="pincodeSelection($event)" bindLabel="pincode" bindValue="pincode"
                    dropdownPosition="top" formControlName='pincode' (keyup)="pincodeSearch($event)" [multiple]="true"
                    [searchable]="true" #selectOwner>
                    <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.pincode}}">{{item.pincode}}</div>
                    </ng-template>
                </ng-select>
                <!-- <ng-select [searchable]="true" (change)="pincodeSelection($event)" formControlName='pincode'
                    (keyup)="pincodeSearch($event)">
                    <ng-option *ngFor="let item of options" [value]="item.pincode">{{item.pincode}}</ng-option>
                </ng-select> -->
            </div>
        </form>
    </div>
    <div class="display-leadscount" *ngIf="totalUsers!=null">
        <p *ngIf="totalUsers>=1">
            {{totalUsers}} Leads Found
        </p>
        <p *ngIf="totalUsers==0 ">
            No Leads Found
        </p>
    </div>
</div>